import { ContextUtils, ObjectBuilder, Image3D, ImgButton, LayoutUtils } from "@dreamcam/babylon-tools";
import { Env } from "../../../settings/Env";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { TextWrapping } from "@babylonjs/gui/2D/controls/textBlock.js";
export class ClientPanel {
    constructor(mesh2d, positionInPixels, sizeInPixels) {
        this._updateClientButtonWidth = () => {
            const btn = Env.common.profileButton.client;
            const minWidthPx = this._mesh2d.m2px(btn.width.min);
            const nicknameRestOfSpacePx = this._mesh2d.m2px(btn.width.restOfTheSpace);
            const balanceRestOfSpacePx = this._mesh2d.m2px(btn.width.restOfTheSpace + btn.balancePanel.spacing + btn.balancePanel.currency.width);
            const maxNicknameTextBlockWidthPx = this._maxWidthInPixels - nicknameRestOfSpacePx;
            const maxBalanceTextBlockWidthPx = this._maxWidthInPixels - balanceRestOfSpacePx;
            const desiredNicknameWidthPx = ContextUtils.MeasureText(this.nicknameTextBlock);
            const desiredBalanceWidthPx = ContextUtils.MeasureText(this.balanceAmountTextBlock);
            const actualNicknameWidthPx = Math.min(desiredNicknameWidthPx, maxNicknameTextBlockWidthPx);
            const actualBalanceWidthPx = Math.min(desiredBalanceWidthPx, maxBalanceTextBlockWidthPx);
            this.nicknameTextBlock.textWrapping = desiredNicknameWidthPx > maxNicknameTextBlockWidthPx
                ? TextWrapping.Ellipsis
                : TextWrapping.Clip;
            this.nicknameTextBlock.widthInPixels = actualNicknameWidthPx;
            this.balanceAmountTextBlock.textWrapping = desiredBalanceWidthPx > maxBalanceTextBlockWidthPx
                ? TextWrapping.Ellipsis
                : TextWrapping.Clip;
            this.balanceAmountTextBlock.widthInPixels = actualBalanceWidthPx;
            this.clientButton.widthInPixels = Math.max(minWidthPx, actualNicknameWidthPx + nicknameRestOfSpacePx, actualBalanceWidthPx + balanceRestOfSpacePx);
        };
        this._mesh2d = mesh2d;
        this._maxWidthInPixels = sizeInPixels.maxWidth;
        const cli = Env.common.profileButton.client;
        this.clientButton = new ImgButton("clientButton", LayoutUtils.GetButtonLayout(cli.colorLayout, mesh2d));
        this.clientButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.clientButton.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this.clientButton.leftInPixels = positionInPixels.left;
        this.clientButton.topInPixels = positionInPixels.top;
        this.clientButton.widthInPixels = mesh2d.m2px(cli.width.min);
        this.clientButton.heightInPixels = mesh2d.m2px(cli.height);
        this.nicknameTextBlock = ObjectBuilder.createTextBlock3D(mesh2d, "clientNickname", "", cli.nickname);
        this.nicknameTextBlock.isHitTestVisible = false;
        this.nicknameTextBlock.onTextChangedObservable.add(this._updateClientButtonWidth);
        this.nicknameTextBlock.stateController.onStateChangedObservable.add(this._updateClientButtonWidth);
        this.clientButton.addControl(this.nicknameTextBlock);
        const balancePanel = new StackPanel("balancePanel");
        balancePanel.isHitTestVisible = false;
        balancePanel.isVertical = false;
        balancePanel.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        balancePanel.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        balancePanel.leftInPixels = mesh2d.m2px(cli.balancePanel.left);
        balancePanel.topInPixels = mesh2d.m2px(cli.balancePanel.top);
        balancePanel.spacing = mesh2d.m2px(cli.balancePanel.spacing);
        this.clientButton.addControl(balancePanel);
        this.balanceAmountTextBlock = ObjectBuilder.createTextBlock3D(mesh2d, "balanceAmount", "", cli.balancePanel.balance);
        this.balanceAmountTextBlock.isHitTestVisible = false;
        this.balanceAmountTextBlock.onTextChangedObservable.add(this._updateClientButtonWidth);
        this.balanceAmountTextBlock.stateController.onStateChangedObservable.add(this._updateClientButtonWidth);
        balancePanel.addControl(this.balanceAmountTextBlock);
        const currency = new Image3D("currency", cli.balancePanel.currency.img);
        currency.isHitTestVisible = false;
        currency.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        currency.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        currency.widthInPixels = mesh2d.m2px(cli.balancePanel.currency.width);
        currency.heightInPixels = mesh2d.m2px(cli.balancePanel.currency.height);
        balancePanel.addControl(currency);
    }
}
